import module from 'finanzas/module.js'

module.config(($stateProvider) => {
  $stateProvider.state('finances.cuentasBancarias.detalle.editar', {
    url: '/:idCuenta',
    template: '<empresa-cuenta empresa-id="empresaId" data="data"></empresa-cuenta>',
    data: {title: 'Cuenta'},
    resolve: {
      idCuenta: ($stateParams) => $stateParams.idCuenta,
      idEmpresa: ($stateParams) => $stateParams.idEmpresa,
      cuenta: (EmpresaCuenta, idEmpresa, idCuenta) => EmpresaCuenta.get(idEmpresa, idCuenta).then((response) => response.data),
    },
    controller ($scope, idEmpresa, cuenta) {
      $scope.empresaId = idEmpresa
      $scope.data = cuenta
    },
  })
})



// WEBPACK FOOTER //
// ./src/finanzas/_/bancosCuentas/routes/cuentasBancarias/detalle/editar.js